var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errorView"},[_c('el-image',{staticClass:"errorImage",attrs:{"src":_vm.ship1,"mode":"aspectFit"}}),_c('div',{staticClass:"errorMessage"},[_vm._v(_vm._s(_vm.$t("common.noData2")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }